"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CircleCrossLarge = exports.CircleCrossLargeDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var cn_1 = require("../../utils/cn");
var use_theme_eval_1 = require("../../hooks/use-theme-eval");
var cls = (0, cn_1.classNames)('circle-cross-small');
exports.CircleCrossLargeDefaultProps = {
  fill: 'primary',
  stroke: 'light'
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
var CircleCrossLarge = function (props) {
  var className = props.className,
    fill = props.fill,
    stroke = props.stroke,
    onClick = props.onClick;
  var $ = (0, use_theme_eval_1.useThemeEval)();
  return react_1.default.createElement("svg", {
    onClick: onClick,
    width: "80",
    height: "80",
    viewBox: "0 0 80 80",
    fill: "none",
    className: cls.name(className)
  }, react_1.default.createElement("circle", {
    cx: "40",
    cy: "40",
    r: "39.5",
    fill: $(theme_1.theme.COLOR(fill)),
    stroke: $(theme_1.theme.COLOR(stroke))
  }), react_1.default.createElement("path", {
    d: "M32.5 32.5L47.5 47.5",
    stroke: $(theme_1.theme.COLOR(stroke))
  }), react_1.default.createElement("path", {
    d: "M32.5 47.5L47.5 32.5",
    stroke: $(theme_1.theme.COLOR(stroke))
  }));
};
exports.CircleCrossLarge = CircleCrossLarge;
exports.CircleCrossLarge.defaultProps = exports.CircleCrossLargeDefaultProps;
var templateObject_1, templateObject_2;